import { intervalToDuration } from 'date-fns'

export function cpfMask(cpf) {
  if (!cpf) return ''
  const cleanedCPF = cpf.replace(/\D/g, '')
  if (cleanedCPF.length !== 11) {
    throw new Error('Invalid CPF length')
  }
  const maskedCPF = cleanedCPF.replace(
    /(\d{3})(\d{3})(\d{3})(\d{2})/,
    '$1.$2.$3-$4',
  )
  return maskedCPF
}

export function phoneMask(phone) {
  if (!phone) return ''
  const cleanedPhone = phone.replace(/\D/g, '')

  if (cleanedPhone.length <= 2) {
    return `(${cleanedPhone}`
  } else if (cleanedPhone.length <= 6) {
    return `(${cleanedPhone.slice(0, 2)}) ${cleanedPhone.slice(2)}`
  } else if (cleanedPhone.length <= 10) {
    return `(${cleanedPhone.slice(0, 2)}) ${cleanedPhone.slice(
      2,
      6,
    )}-${cleanedPhone.slice(6)}`
  } else {
    return `(${cleanedPhone.slice(0, 2)}) ${cleanedPhone.slice(
      2,
      7,
    )}-${cleanedPhone.slice(7, 11)}`
  }
}

export function nameAbbreviationMask(fullName) {
  if (!fullName) {
    return ''
  }
  const nameParts = fullName.trim().split(/\s+/)
  if (nameParts.length === 1) {
    const firstLetterFirstName = nameParts[0]?.slice(0, 2).toUpperCase()
    return firstLetterFirstName
  }
  const firstLetterFirstName = nameParts[0]?.charAt(0).toUpperCase()
  const firstLetterLastName = nameParts[nameParts.length - 1]
    ?.charAt(0)
    .toUpperCase()
  return `${firstLetterFirstName}${firstLetterLastName}`
}

// Fn to truncate string and filenames keeping the file extension visible
export function stringTruncMask(str, maxLength) {
  const extensionIndex = str.lastIndexOf('.')
  if (extensionIndex === -1) {
    return str.length > maxLength
      ? str.slice(0, Math.ceil(maxLength / 2)) +
          '...' +
          str.slice(-Math.floor(maxLength / 2))
      : str
  }

  const namePart = str.slice(0, extensionIndex)
  const extensionPart = str.slice(extensionIndex)

  if (str.length <= maxLength) {
    return str
  }

  const charsToShow = maxLength - extensionPart.length - 3
  const frontChars = Math.ceil(charsToShow / 2)
  const backChars = Math.floor(charsToShow / 2)

  return (
    namePart.slice(0, frontChars) +
    '...' +
    namePart.slice(-backChars) +
    extensionPart
  )
}

export function formatSecondsToTime(seconds) {
  const duration = intervalToDuration({ start: 0, end: seconds * 1000 })
  const hours = duration.hours || 0
  const minutes = duration.minutes || 0

  if (hours > 0) {
    return `${hours}h${minutes.toString().padStart(2, '0')}`
  }
  return `${minutes.toString().padStart(minutes < 1 ? 1 : 2, '0')}m`
}
